import { Build, Component, h, Host, Prop } from '@stencil/core';

@Component({
  tag: 'mp-foreground-text',
  styleUrl: 'mp-foreground-text.scss',
})
export class MpForegroundText {



  @Prop() index!: number;
  @Prop() collections!: any[];
  @Prop() sectionIndex: number;
  @Prop() level: number = 0;
  @Prop() embedded: boolean;
  @Prop() buttons: HTMLMpForegroundButtonElement[];


  private item: any = {};
  private content: HTMLElement;
  private content_wrapper: HTMLDivElement;
  private buttons_wrapper: HTMLDivElement;

  private is_inline: boolean = false;


  componentWillLoad() {

    this.item = this.collections?.[this.index]?.item;

    this.is_inline = this.item?.inline_images ?? false;

    this.content = document.createElement('div');
    this.content.innerHTML = this.item?.translations[0]?.text ?? '';

    let first: HTMLElement = null;
    let headline: HTMLElement = null;
    if (this.item?.headline_icon) {
      first = this.content.firstElementChild as HTMLElement;
      if (first && first.tagName.toLowerCase() == 'h1') {
        headline = document.createElement('div');
        headline.classList.add('mp-foreground-text-headline');
        const wrapper = document.createElement('div');
        const icon = document.createElement(this.item.headline_icon.component);
        wrapper.append(icon);
        headline.append(wrapper);
        if (typeof first.replaceWith == 'function') first.replaceWith(headline);
        headline.append(first);
      }
    }

    if (!Build.isBrowser) return;
      
    const images = this.content.querySelectorAll('img');
    for (let i=0, l=images.length; i<l; i++) {

      const image = images[i];

      const hylo_responsive_image = document.createElement('hylo-responsive-image');
      hylo_responsive_image.setAttribute('alt', image.alt);

      let alignment = 'default';

      if (this.is_inline) {
        const p = image.closest('p') || image.closest('h1') || image.closest('h2') || image.closest('h3') || image.closest('h4') || image.closest('h5') || image.closest('h6');

        hylo_responsive_image.classList.add('img-is-inline');
        if (p?.childElementCount < 2 && image.parentElement.childElementCount < 2 && !p.textContent.trim().length) hylo_responsive_image.classList.add('img-is-single');

        if (image.style.float == 'left') {
          hylo_responsive_image.classList.add('img-float-left');
          alignment = 'left';
        } else if (image.style.float == 'right') {
          hylo_responsive_image.classList.add('img-float-right');
          alignment = 'right';
        } else if (image.style.display == 'block') {
          hylo_responsive_image.classList.add('img-align-center');
          alignment = 'center';
        } else {
          if (p?.style.textAlign == 'justify') hylo_responsive_image.classList.add('img-full-width');
          alignment = 'full';
        }
      }
      
      if (headline && headline.contains(image)) headline.after(image);

      const xl = document.createElement('hylo-image');
      const lg = document.createElement('hylo-image');
      const md = document.createElement('hylo-image');
      const sm = document.createElement('hylo-image');
      const xs = document.createElement('hylo-image');
      xl.setAttribute('xl', '');
      lg.setAttribute('lg', '');
      md.setAttribute('md', '');
      sm.setAttribute('sm', '');
      xs.setAttribute('xs', '');
      xl.src = lg.src = md.src = sm.src = xs.src = image.src.split('?')[0];
      
      if (alignment == 'left' || alignment == 'right') {
        xl.src += '?key=image-fill-half-xl';
        lg.src += '?key=image-fill-half-lg';
        md.src += '?key=image-fill-half-md';
        sm.src += '?key=image-fill-sm';
        xs.src += '?key=image-fill-xs';
      } else if (alignment == 'center' || alignment == 'full') {
        xl.src += '?key=image-fill-xl';
        lg.src += '?key=image-fill-lg';
        md.src += '?key=image-fill-md';
        sm.src += '?key=image-fill-sm';
        xs.src += '?key=image-fill-xs';
      } else {
        xl.src += '?key=image-content-sm';
        lg.src += '?key=image-content-sm';
        md.src += '?key=image-content-xs';
        sm.src += '?key=image-content-xs';
        xs.src += '?key=image-content-sm';
      }

      xl.setAttribute('src', xl.src);
      lg.setAttribute('src', lg.src);
      md.setAttribute('src', md.src);
      sm.setAttribute('src', sm.src);
      xs.setAttribute('src', xs.src);

      hylo_responsive_image.append(xl);
      hylo_responsive_image.append(lg);
      hylo_responsive_image.append(md);
      hylo_responsive_image.append(sm);
      hylo_responsive_image.append(xs);

      if (typeof image.replaceWith == 'function') image.replaceWith(hylo_responsive_image);
      image.removeAttribute('src');
    }

    //console.log(this.buttons);
  }

  componentDidLoad() {
    this.prepareTables();
    this.renderButtons();
  }


  private prepareTables() {

    const tables = this.content_wrapper.querySelectorAll('table:not(.prepared)');
    for (let i=0, l=tables.length; i<l; i++) {

      const table = tables[i];
      table.classList.add('prepared');

      if (!Build.isBrowser) return;
      
      const paragraphs = table.querySelectorAll('p');
      paragraphs.forEach(paragraph => {
        const fragment = document.createDocumentFragment();
        while (paragraph.firstChild) {
          fragment.appendChild(paragraph.firstChild);
        }
        paragraph.parentNode.replaceChild(fragment, paragraph);
      });

      const drag = document.createElement('hylo-drag-area');
      drag.widthReference = this.content_wrapper;
      drag.disableVertical = true;
      drag.scrollX = true;
      drag.scrollToFocus = true;
      drag.scrollToKeyFocus = true;
      drag.showScrollbar = true;

      table.after(drag);
      drag.append(table);
    }
  }

  private renderButtons() {
    if (this.content_wrapper && this.buttons_wrapper) {
      while (this.buttons_wrapper.firstChild) {
        this.content_wrapper.appendChild(this.buttons_wrapper.firstChild);
      }
      this.buttons_wrapper.remove();
      this.buttons_wrapper = null;
    }
  }

  private getEmbedded(content: any) {

    if (this.embedded) return content;

    return <hylo-page-width>{content}</hylo-page-width>;
  }


  render() {

    const style = {
      "--mp-foreground-text-image-offset": this.item?.image_offset ? this.item.image_offset+'px' : null,
      "--mp-foreground-text-max-width": this.item?.max_width ? '100%' : null,
      "--mp-foreground-text-image-max-width": this.item?.images_max_width ? this.item.images_max_width : null
    };

    const classes = {
      "mp-foreground-text-newspaper": this.item?.newspaper ? true : false
    }

    return (
      <Host class={classes} style={style}>{this.getEmbedded(<div>
        <mp-top-logo index={Math.max(this.sectionIndex, this.index)} level={this.level}/>
        <div ref={el => this.content_wrapper = el} class="mp-foreground-text-copy mp-copy" innerHTML={this.content?.innerHTML} />
        {!!this.buttons && <div ref={el => this.buttons_wrapper = el} class="mp-foreground-text-buttons">
          {this.buttons.map(button => <div>{button}</div>)}
        </div>}
      </div>)}</Host>
    )
  }
}

